export default __webpack_public_path__ + "media/images/landing-34-550x420-c8a05dd4b6d14a9b8346e8dd10a87a78.jpg";